import React, { useState, useEffect, useRef } from "react";
import { Table, Col, Button, Space, Spin } from "antd";
import { Link, useParams } from "react-router-dom";
import { DownloadOutlined } from "@ant-design/icons";
import { getRequest } from "../../axios";
import PropTypes from "prop-types";
import ButtonField from "../../common/htmlComponents/ButtonField";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import newLogo from "../../image/PROCEM3.svg";


const SubscriptionPurchaseOrder = () => {
  const [orderData, setOrderData] = useState(null);

  const { id, companyId } = useParams();
  const buttonRef = useRef(null);
  const [isDownloading, setIsDownloading] = useState(false);
  const pdfContainerRef = useRef(null);

  const units = [
    "",
    "ONE",
    "TWO",
    "THREE",
    "FOUR",
    "FIVE",
    "SIX",
    "SEVEN",
    "EIGHT",
    "NINE",
  ];
  const tens = [
    "",
    "TEN",
    "TWENTY",
    "THIRTY",
    "FORTY",
    "FIFTY",
    "SIXTY",
    "SEVENTY",
    "EIGHTY",
    "NINETY",
  ];
  const teens = [
    "TEN",
    "ELEVEN",
    "TWELVE",
    "THIRTEEN",
    "FOURTEEN",
    "FIFTEEN",
    "SIXTEEN",
    "SEVENTEEN",
    "EIGHTEEN",
    "NINETEEN",
  ];

  const zero = "ZERO";
  const arab = "ARAB";
  const crore = "CRORE";
  const lakh = "LAKH";
  const thousand = "THOUSAND";
  const hundred = "HUNDRED";
  const currency = "RUPEES";
  const paisa = "PAISA";
  const only = "ONLY";

  const convertNumberToWords = (amount) => {
    if (amount === 0) return `${currency} ${zero} ${only}`;

    function convert(num) {
      let parts = [];
      if (num >= 1e9) {
        parts.push(`${convert(Math.floor(num / 1e9))} ${arab}`);
        num %= 1e9;
      }
      if (num >= 1e7) {
        parts.push(`${convert(Math.floor(num / 1e7))} ${crore}`);
        num %= 1e7;
      }
      if (num >= 1e5) {
        parts.push(`${convert(Math.floor(num / 1e5))} ${lakh}`);
        num %= 1e5;
      }
      if (num >= 1000) {
        parts.push(`${convert(Math.floor(num / 1000))} ${thousand}`);
        num %= 1000;
      }
      if (num >= 100) {
        parts.push(`${convert(Math.floor(num / 100))} ${hundred}`);
        num %= 100;
      }
      if (num >= 20) {
        parts.push(`${tens[Math.floor(num / 10)]}`);
        if (num % 10 > 0) parts.push(units[num % 10]);
      } else if (num >= 10) {
        parts.push(`${teens[num - 10]}`);
      } else if (num > 0) {
        parts.push(`${units[num]}`);
      }
      return parts.join(" ");
    }

    let integerPart = Math.floor(amount);
    let wholeWordPart = convert(integerPart);
    let result = wholeWordPart ? `${currency} ${wholeWordPart} ` : "";

    let decimalPart = Math.round((amount - integerPart) * 100);
    if (decimalPart > 0) {
      if (wholeWordPart) {
        result += " AND ";
      }
      result += `${convert(decimalPart)} ${paisa}`;
    }

    return `${result} ${only}`;
  };

  useEffect(() => {
    const getPoOrder = async () => {
      try {
        if (!id || !companyId) {
          console.warn("Missing id or companyId");
          return;
        }

        const response = await getRequest(
          `payment-subscription/${id}/download-invoice/?company_id=${companyId}`
        );

        if (response?.data?.data) {
          setOrderData(response.data.data);
        } else {
          console.error("Unexpected API response structure", response);
        }
      } catch (error) {
        console.error("Error fetching invoice:", error);
      }
    };

    getPoOrder();
  }, [id, companyId]);


  if (!orderData) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spin size="large" tip="Loading..." />
      </div>
    );
  }


  // const downloadAsPDF = () => {
  //   if (pdfContainerRef.current) {
  //     setIsDownloading(true);

  //     if (buttonRef.current) {
  //       buttonRef.current.classList.add("hide-in-pdf");
  //     }

  //     html2canvas(pdfContainerRef.current, {
  //       useCORS: true,
  //       allowTaint: false,
  //       scrolling: true,
  //       scale: 2,
  //       logging: true,
  //     })
  //       .then((canvas) => {
  //         const imgData = canvas.toDataURL("image/png");

  //         const pdf = new jsPDF("p", "mm", "a4");
  //         const imgProps = pdf.getImageProperties(imgData);
  //         const pdfWidth = pdf.internal.pageSize.getWidth(); 
  //         const pdfHeight = pdf.internal.pageSize.getHeight(); 

  //         const canvasAspectRatio = canvas.width / canvas.height;
  //         const pdfAspectRatio = pdfWidth / pdfHeight; 

  //         let imgWidth, imgHeight;

  //         if (canvasAspectRatio > pdfAspectRatio) {
  //           imgWidth = pdfWidth; 
  //           imgHeight = (canvas.height * pdfWidth) / canvas.width;
  //         } else {
  //           imgHeight = pdfHeight; 
  //           imgWidth = (canvas.width * pdfHeight) / canvas.height; 
  //         }

  //         const xOffset = (pdfWidth - imgWidth) / 2; 
  //         const yOffset = (pdfHeight - imgHeight) / 2; 
  //         pdf.addImage(imgData, "PNG", xOffset, yOffset, imgWidth, imgHeight);
  //         pdf.save(`Invoice-${orderData.invoice_no}.pdf`);

  //         if (buttonRef.current) {
  //           buttonRef.current.classList.remove("hide-in-pdf");
  //         }
  //         setIsDownloading(false);
  //       })
  //       .catch((error) => {
  //         console.error("Error generating PDF:", error);
  //         if (buttonRef.current) {
  //           buttonRef.current.classList.remove("hide-in-pdf");
  //         }
  //         setIsDownloading(false);
  //       });
  //   } else {
  //     console.error("PDF container reference is not defined.");
  //   }
  // };
  
  const preloadImages = () => {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = newLogo;
      img.onload = resolve;
      img.onerror = resolve;
    });
  };
  const downloadAsPDF = async () => {
    if (!orderData || !pdfContainerRef.current) {
      console.error("Data or container not ready.");
      setIsDownloading(false);
      return;
    }

    setIsDownloading(true);
    await preloadImages();

    if (buttonRef.current) {
      buttonRef.current.classList.add("hide-in-pdf");
    }

    html2canvas(pdfContainerRef.current, {
      useCORS: true,
      allowTaint: false,
      scale: 1,
      logging: true,
      scrollX: 0,
      scrollY: 0,
      windowWidth: pdfContainerRef.current.scrollWidth,
      windowHeight: pdfContainerRef.current.scrollHeight,
    })
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/png");

        const pdf = new jsPDF("p", "mm", "a4");
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();

        const canvasAspectRatio = canvas.width / canvas.height;
        const pdfAspectRatio = pdfWidth / pdfHeight;

        let imgWidth, imgHeight;

        if (canvasAspectRatio > pdfAspectRatio) {
          imgWidth = pdfWidth;
          imgHeight = pdfWidth / canvasAspectRatio;
        } else {
          imgHeight = pdfHeight;
          imgWidth = pdfHeight * canvasAspectRatio;
        }

        const xOffset = (pdfWidth - imgWidth) / 2;
        const yOffset = (pdfHeight - imgHeight) / 2;
        pdf.addImage(imgData, "PNG", xOffset, yOffset, imgWidth, imgHeight);
        pdf.save(`Invoice-${orderData.invoice_no}.pdf`);

        if (buttonRef.current) {
          buttonRef.current.classList.remove("hide-in-pdf");
        }
        setIsDownloading(false);
      })
      .catch((error) => {
        console.error("Error generating PDF:", error);
        if (buttonRef.current) {
          buttonRef.current.classList.remove("hide-in-pdf");
        }
        setIsDownloading(false);
      });
  };
  
  
  const columns = [
    {
      title: "Sr.",
      dataIndex: "sr",
      width: "90px",
      align: "center",
    },
    {
      title: "Subscription name",
      dataIndex: "subscription_name",
      align: "center",
    },
    {
      title: "Rate",
      dataIndex: "rate",
      align: "right",
      render: (text) => (
        <>{`₹ ${text?.toLocaleString("en-IN", {
          maximumFractionDigits: 0,
        })}`}</>
      ),
    },
    {
      title: "Discount",
      dataIndex: "discount",
      align: "right",
      render: (text) => <>{`${text} %`}</>,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      align: "right",
      render: (text) => (
        <>{`₹ ${text?.toLocaleString("en-IN", {
          maximumFractionDigits: 0,
        })}`}</>
      ),
    },

  ];

  const data = [
    {
      sr: 1,
      subscription_name: orderData.invoice_data.subscription_name,
      rate: orderData.invoice_data.rate,
      discount: orderData.invoice_data.discount,
      amount: orderData.invoice_data.amount,
      total_amount: orderData.invoice_data.total_amount,
    },
  ];


  return (
    <div className="invoice-container">
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>Subscription Invoice</h3>
          </div>
          <Space>
            <ButtonField
              className="BlueShadowBtn"
              type="primary"
              icon={<DownloadOutlined />}
              label={isDownloading ? "Downloading..." : "Download PDF"}
              onClick={downloadAsPDF}
              ref={buttonRef}
            >
              Download
            </ButtonField>
          </Space>
        </div>
      </div>

      <section className="grid-sec mt-5" ref={pdfContainerRef}>
        <div className="PR-body">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <img src={newLogo} alt="Default Company Logo" />

            <div>
              <h3>TAX INVOICE</h3>
              <table>
                <tr>
                  <th>
                    <b>Invoice No:</b>
                  </th>
                  <td>
                    <b>{orderData.invoice_no}</b>
                  </td>
                </tr>
                <tr>
                  <th>
                    <b>Invoice Date:</b>
                  </th>
                  <td>
                    <b>{orderData.date}</b>
                  </td>
                </tr>
              
              </table>
            </div>
          </div>
          <div className="invofooter po1"></div>
          <div className="order-header">
            <div className="headdtl">
              <h3>From</h3>
              <table className="table-style" border="true">
                <tbody>
                  <tr>
                    <td>Name:</td>
                    <td className="table-style-head">{orderData.from.name}</td>
                  </tr>
                  <tr>
                    <td>Mobile:</td>
                    <td className="table-style-head">{orderData.from.phone}</td>
                  </tr>
                  <tr>
                    <td>Email:</td>
                    <td className="table-style-head">{orderData.from.email}</td>
                  </tr>
                  <tr>
                    <td>Address:</td>
                    <td className="table-style-head">{orderData.to.address}</td>
                  </tr>
                  <tr>
                    <td>GSTN:</td>
                    <td className="table-style-head">
                      {orderData.from.gst_no}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="headdtl">
              <h3>Bill To</h3>
              <table className="table-style" border="true">
                <tbody>
                  <tr>
                    <td>Name:</td>
                    <td className="table-style-head">{orderData.to.name}</td>
                  </tr>
                  <tr>
                    <td>Mobile:</td>
                    <td className="table-style-head">{orderData.to.phone}</td>
                  </tr>
                  <tr>
                    <td>Email:</td>
                    <td className="table-style-head">{orderData.to.email}</td>
                  </tr>
                  <tr>
                    <td>Address:</td>
                    <td className="table-style-head">{orderData.to.address}</td>
                  </tr>
                  <tr>
                    <td>GSTN:</td>
                    <td className="table-style-head">{orderData.to.gst_no}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <Table
            className="poordertbl"
            columns={columns}
            dataSource={data}
            pagination={false}
          />
          <div className="invofooter po1">
            <table>
              <tr>
                <th>Sub Total:</th>
                <td>
                  <b>
                    ₹{" "}
                    {orderData?.invoice_data?.amount?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })}
                  </b>
                </td>
              </tr>
              <tr>
                <th>CGST:</th>
                <td>
                  ₹{" "}
                  {orderData?.invoice_data?.cgst?.toLocaleString("en-IN", {
                    maximumFractionDigits: 0,
                  })}
                </td>
              </tr>
              <tr>
                <th>SGST:</th>
                <td>
                  ₹{" "}
                  {orderData?.invoice_data?.sgst?.toLocaleString("en-IN", {
                    maximumFractionDigits: 0,
                  })}
                </td>
              </tr>
              <tr>
                <th className="ttlbg">
                  <b>Total:</b>
                </th>
                <td className="ttlbg">
                  <b>
                    ₹{" "}
                    {orderData?.invoice_data?.total_amount?.toLocaleString(
                      "en-IN",
                      {
                        maximumFractionDigits: 0,
                      }
                    )}
                  </b>
                </td>
              </tr>
            </table>
          </div>
          <div className="hltxt">
            AMOUNT IN WORDS:{" "}
            <b>
              {convertNumberToWords(
                orderData?.invoice_data?.total_amount?.toFixed(0)
              )}
            </b>
          </div>
          <div className="orderpdtl ftrsigntbl rightalign">
            <p className="authsign">
              <br />
              Authorised Signatory
            </p>
          </div>

          <div className="headdtl" style={{width:'fit-content'}}>
              <h3>Bank Details</h3>
              <table className="table-style" border="true">
                <tbody>
                  <tr>
                    <td ><b>Company:</b></td>
                    <td className="table-style-head">{orderData?.bank_details?.company_name}</td>
                  </tr>
                  <tr>
                    <td ><b>IFSC:</b></td>
                    <td className="table-style-head">{orderData?.bank_details?.ifsc_code}</td>
                  </tr>
                  <tr>
                    <td ><b>Account No.:</b></td>
                    <td className="table-style-head">{orderData?.bank_details?.account_no}</td>
                  </tr>
                  <tr>
                    <td ><b>Bank:</b></td>
                    <td className="table-style-head">{orderData?.bank_details?.bank_name}</td>
                  </tr>
                 
                
                 
                </tbody>
              </table>
            </div>
        </div>
      </section>
    </div>
  );
};

SubscriptionPurchaseOrder.propTypes = {
  id: PropTypes.number,
  vendorId: PropTypes.number,
};

export default SubscriptionPurchaseOrder;
